import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useReveal } from '../../hooks/useReveal';
import { Eye, ShieldCheck, Layers, BarChart3 } from 'lucide-react';

const Values = () => {
  const { t } = useLanguage();
  const [ref, visible] = useReveal();

  const items = [
    { icon: Eye, key: 'v1' },
    { icon: ShieldCheck, key: 'v2' },
    { icon: Layers, key: 'v3' },
    { icon: BarChart3, key: 'v4' },
  ];

  return (
    <section id="values" ref={ref} className="py-24 bg-[#0A1628]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">{t('values.title')}</h2>
          <div className="w-16 h-1 bg-[#00B4D8] mx-auto mt-6 rounded-full" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={i} data-testid={`value-card-${i}`}
                className={`bg-white/5 border border-white/10 rounded-xl p-6 text-center hover:border-[#00B4D8]/30 hover:bg-white/[0.07] transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionDelay: visible ? `${100 + i * 80}ms` : '0ms' }}>
                <div className="w-12 h-12 bg-[#00B4D8]/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-6 h-6 text-[#00B4D8]" />
                </div>
                <p className="text-white font-medium text-sm">{t(`values.${item.key}`)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
